import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form-group mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputPhone = _resolveComponent("InputPhone")!
  const _component_CodeInput = _resolveComponent("CodeInput")!
  const _component_MessageError = _resolveComponent("MessageError")!
  const _component_ButtonSubmit = _resolveComponent("ButtonSubmit")!
  const _component_ButtonSendCode = _resolveComponent("ButtonSendCode")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "p-8 py-7 bg-white w-10/12" }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: _normalizeClass([{ submitted: _ctx.data.submitted }]),
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        (_ctx.data.isLogin === false)
          ? (_openBlock(), _createBlock(_component_InputPhone, {
              key: 0,
              phone: _ctx.data.model.phone,
              "onUpdate:phone": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.model.phone) = $event))
            }, null, 8, ["phone"]))
          : (_openBlock(), _createBlock(_component_CodeInput, {
              key: 1,
              code: _ctx.data.model.code,
              "onUpdate:code": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.model.code) = $event))
            }, null, 8, ["code"])),
        _createVNode(_component_MessageError, {
          message: _ctx.data.messageError
        }, null, 8, ["message"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ButtonSubmit, {
            isLogin: _ctx.data.isLogin,
            isDisabled: _ctx.submitButtonDisabled
          }, null, 8, ["isLogin", "isDisabled"]),
          (_ctx.data.isLogin)
            ? (_openBlock(), _createBlock(_component_ButtonSendCode, {
                key: 0,
                sendCode: _ctx.sendCode
              }, null, 8, ["sendCode"]))
            : _createCommentVNode("", true)
        ])
      ], 34)
    ]),
    _: 1
  }))
}